import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import CoursesPage from './pages/CoursesPage';
import CoursePage from './pages/CoursePage';
import ProfilePage from './pages/ProfilePage';
import AdminPage from './pages/AdminPage';

const attachGoogleClientIdToConfig = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const envClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined;

  if (!envClientId) {
    return;
  }

  if (!window.ywConfig) {
    window.ywConfig = {} as Record<string, unknown>;
  }

  if (!window.ywConfig.google_client_id) {
    window.ywConfig.google_client_id = envClientId;
  }
};

function App() {
  const { initializeFromStorage, updateSubscriptionsTimer } = useAuthStore();

  useEffect(() => {
    attachGoogleClientIdToConfig();
  }, []);

  useEffect(() => {
    // استرداد البيانات من التخزين المحلي عند بدء التطبيق
    initializeFromStorage();

    // تحديث الاشتراكات كل دقيقة
    const timer = setInterval(() => {
      updateSubscriptionsTimer();
    }, 60000); // كل دقيقة

    // تحديث فوري عند تحميل الصفحة
    updateSubscriptionsTimer();

    return () => clearInterval(timer);
  }, [initializeFromStorage, updateSubscriptionsTimer]);

  return (
    <Router>
      <div className="App" dir="rtl">
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/course/:id" element={<CoursePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;